/* eslint-disable */
import { Model } from '@vuex-orm/core'

class CTTProvince extends Model {
  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
    }
  }

  static list(options = {}) {
    return this.api().request({
      method: 'GET',
      url: `/chang-tt/provinces`,
      ...options,
    }).then((res) => res.response.data)
  }
}

CTTProvince.entity = 'province'

export default CTTProvince